export default {
  isMobile(v) {
    return /^(1[\d]{10})$/.test(v);
  },
  validNull(data) {
    if (data === '' || data == undefined || data == null) {
      return true;
    }
    return false;
  },
  // 验证邮箱
  isEmail(data) {
    return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(data);
  },
  // 验证证件号
  isIdNo(data) {
    return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|x|X)$/.test(data);
  },
  // 1-10验证
  isNum(data) {
    return /^(\d|10)(\.\d)?$/.test(data);
  },
};
